<div class="wrapper wrapper-content mtv-directory-page animated fadeInRight row hide-list-nav-tabs">
    <div class="ibox mainPartPage"
         [class.showDetailedView]="ds.isDocumentDetailedModalShow"
         [ngStyle]="{width: ds.isDocumentDetailedModalShow ? 'calc(100% - 420px)' : '100%'}">
        <div class="ibox-content no-scroll-mode">
            <div class="row">
                <div [ngClass]="authenticationService.userIsResident ? 'col-sm-7' : 'col-sm-6'">
                    <filter [tabHeading]="'Documents'" [buildings]="ds.buildingsForRead"></filter>
                </div>
                <div *ngIf="!authenticationService.userIsResident">
                    <documents-status-filter></documents-status-filter>
                </div>

                <div *ngIf="!authenticationService.userIsResident && (!ds.path[0] || (ds.path[0] && ds.path[0].isCanEdit))" class="col-xs-4">
                    <div class="pull-right" *ngIf="ds.canEdit() && !ds.isDocumentDetailedModalShow">
                        <button class="btn btn-w-m btn-default-green" (click)="ds.showCreateFolderModal()">
                            Create Folder
                        </button>
                        <button class="btn btn-w-m btn-primary" (click)="ds.showUploadFileModal()">
                            Upload File
                        </button>
                    </div>
                    <div class="pull-right" *ngIf="ds.canEdit() && ds.isDocumentDetailedModalShow">
                        <button class="btn btn-default-green" (click)="ds.showCreateFolderModal()" style="width: 70px;">
                            Folder
                        </button>
                        <button class="btn btn-primary" (click)="ds.showUploadFileModal()" style="width: 70px;">
                            File
                        </button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <filters-view></filters-view>
                </div>
            </div>

            <directory-path></directory-path>

            <tabs-wrapper>

                <tab-item [tabId]="'document'" [ngClass]="{'sk-loading': isLoading || ds.isUpdating}">
                    <documents-list></documents-list>
                </tab-item>

                <pagination *ngIf="ds.documentsList.length && ds.urlService.queryParams['page']"
                            [total]="ds.data.total">
                </pagination>

                <spinner [spinnerShow]="isLoading || ds.isUpdating"></spinner>

            </tabs-wrapper>
        </div>
    </div>

    <div class="animated animated-directory slideInRight detailed-view dv-sidebar" *ngIf="ds.isDocumentDetailedModalShow">
        <documents-detailed-view *ngIf="ds.selectedItemData"></documents-detailed-view>
    </div>
</div>

<documents-view-modal *ngIf="ds.isDocumentViewModalShow"></documents-view-modal>
<create-folder-modal *ngIf="ds.isCreateFolderModalShow"></create-folder-modal>
<upload-file-modal *ngIf="ds.isUploadFileModalShow"></upload-file-modal>
<edit-permissions-modal *ngIf="ds.isEditPermissionModalShow"></edit-permissions-modal>
<move-modal *ngIf="ds.isMoveModalShow"></move-modal>



// WEBPACK FOOTER //
// /app/src/app/views/documents/documents.component.html